import { inject, provideAppInitializer } from '@angular/core';

import { AppConfigService } from '@services/app-config.service';


// Load config files before app start
export function ConfigFactory(config: AppConfigService) {
  return () => config.loadConfig();
}

// Load translations before app start
export function TranslationsFactory(config: AppConfigService) {
  return () => config.initTranslations();
}

export const appInitializerProviders = [
  provideAppInitializer(() => {
        const initializerFn = (ConfigFactory)(inject(AppConfigService));
        return initializerFn();
      }),
  provideAppInitializer(() => {
        const initializerFn = (TranslationsFactory)(inject(AppConfigService));
        return initializerFn();
      })
];
